import { useState } from "react";

import EvaluationList from "./EvaluationList/EvaluationList";
import EvaluationDetail from "./EvaluationDetail/EvaluationDetail";

import { useAuth } from "../../../Context/AuthContext";
import { fetchSelfPublishingDetailed } from "../../../Api/Backend/SelfPublishing";


function Evaluation({}) {
    const auth = useAuth();

    const [isListView, setIsListView] = useState(true); 
    const [detailedData, setDetailedData] = useState(null);

    const handleListItemClick = async (item) => {
        // console.log("Item clicked: ", item);
        if (!item?.selfPublishingId) {
            alert("Clicked item returned no selfPublishingId");
            return;
        }
        setDetailedData(null);

        await fetchSelfPublishingDetailed({
            auth: auth,
            selfPublishingId: item.selfPublishingId,
            onSuccess: (data) => {
                setDetailedData(data)
                setIsListView(false);
            },
            onError: (error) => {
                console.error("Error fetching detailed user data:", error);
            }
        });
    };

    const handleBackClick = () => {
        setIsListView(true);
        setDetailedData(null);
    };

    return (
        <>
            {isListView ? (
                <EvaluationList onItemClickHandle={handleListItemClick} />
            ) : (
                <EvaluationDetail detailedData={detailedData} onBackClick={handleBackClick}/>
            )}
        </>
    );

}

export default Evaluation;